const Dumbbell3 = ({props}) => (
  <svg
    fill="#ffffff"
    height="30px"
    width="30px"
    viewBox="0 0 511.299 511.299"
    {...props}
  >
    <g strokeWidth="0" />
    <g strokeLinecap="round" strokeLinejoin="round" />
    <g>
      <g>
        <path d="M478.742,32.557c-43.386-43.409-114.02-43.409-157.407,0L211.144,142.748l-15.738-15.738
          c-8.682-8.704-22.773-8.704-31.477,0L6.522,284.416C2.337,288.579,0,294.255,0,300.154c0,5.899,2.337,11.553,6.522,15.738
          l62.954,62.954c4.185,4.185,9.839,6.522,15.738,6.522c5.921,0,11.576-2.337,15.761-6.522L258.36,221.44
          c8.704-8.682,8.704-22.773,0-31.477l-15.738-15.738l47.638-47.616c3.206,23.174,13.29,45.568,31.076,63.354
          s40.181,27.871,63.377,31.076l-47.638,47.638l-15.738-15.738c-8.704-8.704-22.795-8.704-31.477,0L132.452,410.323
          c-8.704,8.704-8.704,22.795,0,31.499l62.954,62.954c4.185,4.185,9.839,6.522,15.738,6.522c5.899,0,11.576-2.337,15.738-6.522
          L384.312,347.37c4.163-4.185,6.522-9.839,6.522-15.738c0-5.899-2.36-11.576-6.522-15.738l-15.761-15.738l110.191-110.191
          C522.151,146.577,522.151,75.943,478.742,32.557z M447.265,158.486c-26.045,26.001-68.408,26.023-94.453,0
          c-26.023-26.045-26.023-68.408,0-94.453c13.023-13.023,30.141-19.523,47.238-19.523c17.096,0,34.193,6.5,47.215,19.523
          C473.311,90.079,473.311,132.441,447.265,158.486z" />
      </g>
    </g>
  </svg>
);

export default Dumbbell3;
